import { Box } from "@mui/material";
import { StoryblokComponent, storyblokEditable } from "@storyblok/react";
import { Helmet } from "react-helmet-async";

const Page = ({ blok }: any) => {
  const { seo } = blok || {};

  return (
    <>
      <Helmet>
        {seo?.title && <title>{seo.title}</title>}
        {seo?.description && <meta name="description" content={seo.description} />}
        <meta property="og:title" content={seo?.title} />
        <meta property="og:description" content={seo?.description} />
        <meta property="og:type" content="website" />
      </Helmet>
      <Box {...storyblokEditable(blok)}>
        {blok.blocks.map((blok: any) => (
          <StoryblokComponent blok={blok} key={blok._uid} />
        ))}
      </Box>
    </>
  );
};

export default Page;
